import { Button } from "@chakra-ui/react"
import { useField } from "formik"
import type React from "react"
import type { ReactNode } from "react"

interface PCButtonProps {
  children: ReactNode
  name: string
  [key: string]: any // Allow additional props
}

const PCButton: React.FC<PCButtonProps> = ({ children, ...props }) => {
  const [field] = useField({ ...props, type: "checkbox" })

  return (
    <Button {...field} {...props}>
      {children}
    </Button>
  )
}

export default PCButton
